import { cx, css } from "@emotion/css";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import type React from "react";
const arrowStyles = {
    container: css({
        display: "inline-block",
        paddingRight: "0.5em",
        cursor: "pointer",
    }),
    base: css({
        marginLeft: 0,
        transition: "150ms",
        transformOrigin: "45% 50%",
        position: "relative",
        lineHeight: "1.1em",
        fontSize: "0.75em",
    }),
    expanded: (expanded: boolean) => css({
        transform: expanded ? "rotateZ(90deg)" : "rotateZ(0deg)",
    }),
    sign: css({
        color: themeTokens.color.button.icon.secondary,
    }),
};
interface Props {
    expanded: boolean;
    onClick: React.MouseEventHandler<HTMLDivElement>;
}
export default function JSONArrow({ expanded, onClick }: Props) {
    return (<div className={arrowStyles.container} onClick={onClick}>
            <div className={cx(arrowStyles.base, arrowStyles.expanded(expanded), arrowStyles.sign)}>{"\u25B6"}</div>
        </div>);
}
